
import { useState } from 'react';
import { Form, FormLabel, FormControl, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import Func from '../../function/Func';
import ApiUtil from '../../util/ApiUtil';
import ApiPath from '../../util/ApiPath';

function Email({email, setEmail, handleClick }) {

    const { t } = useTranslation(); // Use t instead of lang
    const [validated, setValidated] = useState(false);
    const [msgErrorEmail, setMsgErrorEmail] = useState(t("Please enter") + ' ' + t('Email'));
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setMsgErrorEmail(Func.verifyEmail(value, t))
        setEmail(value);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (email && !msgErrorEmail) {
            const res = await ApiUtil.postApi(ApiPath.FORGET_PASSWORD,{'Email':email}, 'POST')
            if (res.IsSuccessfull) {
                setValidated(true)
                handleClick('OTPInput');
            } else {
                setValidated(false);
                setMsgErrorEmail(t(res.Errors[0].Message))
            }
        }
    }
    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <p className='text-center'>{t('ToResetYourPassword')}</p>
            {/* Email */}
            <Form.Group className="mb-3" controlId="formGroupEmail">
                <FormLabel className="font-SemiBold">{t("Email")}</FormLabel>
                <FormControl type="email"
                    placeholder={t("Enter") + ' ' + t('Email')}
                    value={email}
                    onChange={handleEmailChange}
                    required
                    isInvalid={!!msgErrorEmail} />
                <Form.Control.Feedback type={(msgErrorEmail !== '' || email === '') ? 'invalid' : 'valid'}>
                    {msgErrorEmail}
                </Form.Control.Feedback>
            </Form.Group>
            <Button aria-label="Aria label" type="submit" className="btn-main w-100 ">{t("Send")}</Button>
        </Form>
    );
}

export default Email;